import {createGlobalStyle} from 'styled-components';

export const Normalize = createGlobalStyle`
    *, html, body, ul, ol, dl, li, dt, dd {
        margin: 0;
        padding: 0;
    }

    html {
        height: 100%;
        line-height: 1.15;
        -webkit-text-size-adjust: 100%;
    }

    body {
        position: relative;
        min-height: 100%;
        margin: auto;
        font-family: 'Oswald-Medium';
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    main {
        display: block;
    }

    h1 {
        font-size: 2em;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
    }

    hr {
        box-sizing: content-box;
        height: 0;
        overflow: visible;
    }

    pre {
        font-family: monospace, monospace;
        font-size: 1em;
    }

    button,
    a {
        -webkit-tap-highlight-color: transparent;
    }

    a {
        outline: none;
        background-color: transparent;
    }

    a:active, a:focus {
        outline: none;
    }

    abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        text-decoration: underline dotted;
    }

    b,
    strong {
        font-weight: bolder;
    }

    code,
    kbd,
    samp {
        font-family: monospace, monospace;
        font-size: 1em;
    }

    small {
        font-size: 80%;
    }

    sub,
    sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
    }

    sub {
        bottom: -0.25em;
    }

    sup {
        top: -0.5em;
    }

    img {
        display: block;
        border: none;
    }

    table {
        border-collapse:collapse;
        border-spacing:0;
    }

    li {
        list-style-type:none;
    }

    header,
    section,
    footer,
    nav,
    article,
    aside {
        display:block
    }

    button,
    input,
    optgroup,
    select,
    textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
    }

    button {
        cursor: pointer;
        background-color: transparent;
        border: none;
        outline: none;
        text-align: left;
    }

    input,
    textarea {
        outline: none;
    }

    input:active,
    textarea:active {
        outline: none;
    }

    button,
    input {
        overflow: visible;
    }

    button:active,
    button:focus {
        outline: none !important;
    }

    button,
    select {
        text-transform: none;
    }

    button,
    [type="button"],
    [type="reset"],
    [type="submit"] {
        -webkit-appearance: button;
    }

    button::-moz-focus-inner,
        [type="button"]::-moz-focus-inner,
        [type="reset"]::-moz-focus-inner,
        [type="submit"]::-moz-focus-inner {
        border-style: none;
        padding: 0;
    }

    button:-moz-focusring,
    [type="button"]:-moz-focusring,
    [type="reset"]:-moz-focusring,
    [type="submit"]:-moz-focusring {
        outline: 1px dotted ButtonText;
    }

    fieldset {
        padding: 0.35em 0.75em 0.625em;
    }

    legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
    }

    progress {
        vertical-align: baseline;
    }

    textarea {
        overflow: auto;
    }

    [type="checkbox"],
    [type="radio"] {
        box-sizing: border-box;
        padding: 0;
    }

    [type="number"]::-webkit-inner-spin-button,
    [type="number"]::-webkit-outer-spin-button {
        height: auto;
    }

    [type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
    }

    [type="search"]::-webkit-search-decoration {
        -webkit-appearance: none;
    }

    ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
    }

    details {
        display: block;
    }

    summary {
        display: list-item;
    }

    template {
        display: none;
    }

    [hidden] {
        display: none;
    }
`;
